import { render } from "./VerticalNavbar.vue?vue&type=template&id=ed8fbae4&scoped=true&ts=true"
import script from "./VerticalNavbar.vue?vue&type=script&lang=ts"
export * from "./VerticalNavbar.vue?vue&type=script&lang=ts"

import "./VerticalNavbar.vue?vue&type=style&index=0&id=ed8fbae4&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed8fbae4"]])

export default __exports__